var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sl-upload-file',{attrs:{"title":_vm.fileId ? '重传' : '上传',"extra-field":_vm.extra,"action":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }